export const ASSET_PAGE_TITLE = "Document Assets";
export const ASSET_PAGE_URL = "assets";

export const ASSET_COLUMN_CONFIG = [
  // {
  //   id: "title",
  //   label: "Title",
  //   isActive: true,
  // },
  {
    id: "tagsType",
    label: "Tags",
    isActive: true,
  },
  {
    id: "status",
    label: "Status",
    isActive: true,
  },
  {
    id: "modifiedBy",
    label: "Last updated",
    isActive: true,
  },
  {
    id: "docuId",
    label: "Document ID",
    isActive: false,
  },
  // {
  //   id: "contact",
  //   label: "Contact",
  //   isActive: false,
  // },
  {
    id: "turnarounddate",
    label: "Turn around date",
    isActive: false,
  },
];

export const COLORS = [
  "#ffffff",
  "#000000",
  "#333333",
  "#888888",
  "#3333ff",
  "#66ccff",
  "#ff001c",
  "#faff00",
  "#9cd326",
  "#427d50",
  "#72c9c5",
  "#9dacbb",
  "#9795ff",
  "#7053c9",
  "#740e0e",
  "#ff0078",
  "#795449",
  "#e26d3f",
  "#f1cb45",
  "#bea938",
  "#99218d",
];

export const ASSET_ITEM_TYPES = {
  DOCUMENT: "DOC_EDITOR",
  DOCUMENT_FORM: "DOC_FORM",
  EXTERNAL_QUOTE: "eq",
  FOLDER: "DIR",
  PDF: "PDF",
};

export const ASSET_ITEM_SETTING_OPTIONS = [
  // {
  //   name: "Duplicate",
  //   argument: null,
  //   icon: ["far", "clone"],
  //   iconClassName: "icon-clone",
  //   action: () =>
  //     toggleActionDropdown(
  //       "showAssetItemRenamePopup",
  //       true,
  //       selectedItem,
  //     ),
  //   isBottomLine: false,
  // },
  {
    id: "delete",
    name: "Delete",
    argument: null,
    icon: ["far", "trash-alt"],
    iconClassName: "icon-trash-alt",
    isBottomLine: false,
  },
  {
    id: "rename",
    name: "Rename",
    argument: null,
    icon: ["far", "pen-square"],
    iconClassName: "icon-pen-square",
    isBottomLine: false,
  },
  {
    id: "addCollaborator",
    name: "Share with teammates",
    argument: null,
    icon: ["fas", "users"],
    iconClassName: "icon-users",
    isBottomLine: false,
  },
  {
    id: "sendToSomeone",
    name: "Send to someone",
    argument: null,
    icon: ["far", "share-square"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
  {
    id: "downloadDoc",
    name: "Download",
    argument: null,
    icon: ["far", "download"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
  {
    id: "clone",
    name: "Clone document",
    argument: null,
    icon: ["far", "clone"],
    iconClassName: "icon-clone",
    isBottomLine: false,
  },
  {
    id: "moveToFolder",
    name: "Move to folder",
    argument: null,
    icon: ["fas", "arrow-circle-right"],
    iconClassName: "icon-folder",
    isBottomLine: false,
  },
];
export const ASSET_TOASTR_MESSAGE = {
  DELETE_DOCUMENT: "Selected items deleted successfully",
  FOLDER_MOVED: "Selected items moved successfully",
};

export const IMAGE_POSITION_OPTIONS = [
  "Top Left",
  "Top Right",
  "Top Center",
  "Center Left",
  "Center Right",
  "Center Center",
  "Bottom Left",
  "Bottom Right",
  "Bottom Center",
];

export const FONT_STYLES_WITH_OPTIONS = [
  "Roboto",
  "Baskerville",
  "EB Garamond",
  "Oswald",
  "Open Sans",
  "Montserrat",
  "Lato",
  "Inter",
  "Playfair Display",
  "Poppins",
  "Kalam",
  "Raleway",
  "Roboto Condensed",
  "Titillium Web",
];



// WEBPACK FOOTER //
// ./src/constants/asset.js